export class RoutinesNamesUtils {
  static getFilteredTexts(value: string, category: string) {
    const dictionary = this.getSearchDictionary(category);

    if (value === '') {
      return dictionary;
    }

    return this.getFilteredTextsFromDictionary(value, dictionary);
  }

  static getSearchDictionary(category: string) {
    const routinesTranslations = Application.modules.riskManagement.controller.helpers.routinesTranslations;
    const routinesNameDictionary = routinesTranslations.getDictionary('short_name');
    const routinesCategoryDictionary = routinesTranslations.getDictionary('category');

    return routinesCategoryDictionary[category].map(key => ({
      value: parseInt(key, 10),
      label: routinesNameDictionary[key],
    }));
  }

  static getFilteredTextsFromDictionary(value: string, dictionary) {
    const filteredTexts: Array<{ value: number }> = [];

    for (const entry of dictionary) {
      if (entry['label'].toLowerCase().indexOf(value.toLowerCase()) > -1) {
        filteredTexts.push(entry);
      }
    }

    return filteredTexts;
  }
}
